import { css } from '@emotion/react';
import { DesignToken, SpacingToken, RadiusToken } from '@livechat/design-system-react-components';

export const requestIDContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing2});
  padding: var(${SpacingToken.Spacing6});
  border-radius: var(${RadiusToken.Radius2});
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
  margin: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing5}) 0;
  word-wrap: break-word;
`;
